/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_RECORD_QUOTATION_DETAILS,
  LOAD_RECORD_QUOTATION_DETAILS_SUCCESS,
  LOAD_RECORD_QUOTATION_DETAILS_ERROR,
  CREATE_QUOTATION_RECORD,
  CREATE_QUOTATION_RECORD_SUCCESS,
  CREATE_QUOTATION_RECORD_ERROR,
  UPDATE_QUOTATION_RECORD,
  UPDATE_QUOTATION_RECORD_SUCCESS,
  UPDATE_QUOTATION_RECORD_ERROR,
  DELETE_QUOTATION_RECORD,
  DELETE_QUOTATION_RECORD_SUCCESS,
  DELETE_QUOTATION_RECORD_ERROR,
  LOAD_DELIVERABLE_DETAILS,
  LOAD_DELIVERABLE_DETAILS_SUCCESS,
  LOAD_DELIVERABLE_DETAILS_ERROR,
  CREATE_DELIVERABLE,
  CREATE_DELIVERABLE_SUCCESS,
  CREATE_DELIVERABLE_ERROR,
  UPDATE_DELIVERABLE,
  UPDATE_DELIVERABLE_SUCCESS,
  UPDATE_DELIVERABLE_ERROR,
  DELETE_DELIVERABLE,
  DELETE_DELIVERABLE_SUCCESS,
  DELETE_DELIVERABLE_ERROR,

  //Value Insert
  LOAD_VALUE_INSERT,
  LOAD_VALUE_INSERT_SUCCESS,
  LOAD_VALUE_INSERT_ERROR,
  CREATE_VALUE_INSERT,
  CREATE_VALUE_INSERT_SUCCESS,
  CREATE_VALUE_INSERT_ERROR,
  UPDATE_VALUE_INSERT,
  UPDATE_VALUE_INSERT_SUCCESS,
  UPDATE_VALUE_INSERT_ERROR,
  DELETE_VALUE_INSERT,
  DELETE_VALUE_INSERT_SUCCESS,
  DELETE_VALUE_INSERT_ERROR,
  CREATE_INSTRUCTIONS,
  CREATE_INSTRUCTIONS_SUCCESS,
  CREATE_INSTRUCTIONS_ERROR,
  LOAD_INSTRUCTIONS,
  LOAD_INSTRUCTIONS_SUCCESS,
  LOAD_INSTRUCTIONS_ERROR,
  UPDATE_INSTRUCTIONS,
  UPDATE_INSTRUCTIONS_SUCCESS,
  UPDATE_INSTRUCTIONS_ERROR,
  DELETE_INSTRUCTIONS,
  DELETE_INSTRUCTIONS_SUCCESS,
  DELETE_INSTRUCTIONS_ERROR,
  CREATE_PHOTOGRAPHY,
  CREATE_PHOTOGRAPHY_SUCCESS,
  CREATE_PHOTOGRAPHY_ERROR,
  UPDATE_PHOTOGRAPHY,
  UPDATE_PHOTOGRAPHY_SUCCESS,
  UPDATE_PHOTOGRAPHY_ERROR,
  DELETE_PHOTOGRAPHY,
  DELETE_PHOTOGRAPHY_SUCCESS,
  DELETE_PHOTOGRAPHY_ERROR,
  LOAD_PHOTOGRAPHY,
  LOAD_PHOTOGRAPHY_SUCCESS,
  LOAD_PHOTOGRAPHY_ERROR,
  LOAD_SERVICE_DETAILS,
  LOAD_SERVICE_DETAILS_SUCCESS,
  LOAD_SERVICE_DETAILS_ERROR,
  LOAD_SALES_APPROVAL,
  LOAD_SALES_APPROVAL_SUCCESS,
  LOAD_SALES_APPROVAL_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_SERVICE_ACCOUNT,
  LOAD_SERVICE_ACCOUNT_SUCCESS,
  LOAD_SERVICE_ACCOUNT_ERROR,
  APPROVE_QC_REQUEST,
  APPROVE_QC_REQUEST_SUCCESS,
  APPROVE_QC_REQUEST_ERROR,
  LOAD_QUOTATION_HISTORY_DETAILS,
  LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS,
  LOAD_QUOTATION_HISTORY_DETAILS_ERROR,
  LOAD_QC_HISTORY,
  LOAD_QC_HISTORY_SUCCESS,
  LOAD_QC_HISTORY_ERROR,
  UPDATE_QC_REAPPROVE,
  UPDATE_QC_REAPPROVE_SUCCESS,
  UPDATE_QC_REAPPROVE_ERROR,
  UPDATE_QUOTATION_LIST,
  UPDATE_QUOTATION_LIST_SUCCESS,
  UPDATE_QUOTATION_LIST_ERROR,
  LOAD_QUOTATION_LIST,
  LOAD_QUOTATION_LIST_SUCCESS,
  LOAD_QUOTATION_LIST_ERROR,
  LOAD_QC_LAYOUT_MASTER,
  LOAD_QC_LAYOUT_MASTER_SUCCESS,
  LOAD_QC_LAYOUT_MASTER_ERROR,
  LOAD_QC_LAYOUT_SEGMENT,
  LOAD_QC_LAYOUT_SEGMENT_SUCCESS,
  LOAD_QC_LAYOUT_SEGMENT_ERROR,

  //Quotation preview
  LOAD_QUOTATION_PREVIEW,
  LOAD_QUOTATION_PREVIEW_SUCCESS,
  LOAD_QUOTATION_PREVIEW_ERROR,
  UPDATE_EXPIRY_DATE,
  UPDATE_EXPIRY_DATE_SUCCESS,
  UPDATE_EXPIRY_DATE_ERROR,
  UPDATE_QUOTATION_PREVIEW,
  UPDATE_QUOTATION_PREVIEW_SUCCESS,
  UPDATE_QUOTATION_PREVIEW_ERROR,
  ADD_SEGMENT_PREVIEW,
  ADD_SEGMENT_PREVIEW_SUCCESS,
  ADD_SEGMENT_PREVIEW_ERROR,


  ADD_TEAM_ASSIGN,
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  ADD_PRODUCT_ASSIGN,
  ADD_PRODUCT_ASSIGN_SUCCESS,
  ADD_PRODUCT_ASSIGN_ERROR,

  UPDATE_CRM_DELIVER,
  UPDATE_CRM_DELIVER_SUCCESS,
  UPDATE_CRM_DELIVER_ERROR,

  LOAD_EC_DELIVERABLE_DETAILS,
  LOAD_EC_DELIVERABLE_DETAILS_SUCCESS,
  LOAD_EC_DELIVERABLE_DETAILS_ERROR,

  LOAD_DELIVERABLE_EMPLOYEE,
  LOAD_DELIVERABLE_EMPLOYEE_SUCCESS,
  LOAD_DELIVERABLE_EMPLOYEE_ERROR,
  UPDATE_DISCOUNT_PREVIEW,
  UPDATE_DISCOUNT_PREVIEW_SUCCESS,
  UPDATE_DISCOUNT_PREVIEW_ERROR,

  UPDATE_PROCESS,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_ERROR,

  ADD_CRM,
  ADD_CRM_SUCCESS,
  ADD_CRM_ERROR,

  LOAD_PROCESS_STATUS,
  LOAD_PROCESS_STATUS_SUCCESS,
  LOAD_PROCESS_STATUS_ERROR,
  LOAD_DELIVERABLES_RECORDS_META_DATA,
  LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS,
  LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 * @param {integer} id
 */
export function loadRecordQuotationDetails(id) {
  return {
    type: LOAD_RECORD_QUOTATION_DETAILS,
    id,
  }
}

export function loadRecordQuotationDetailsSuccess(record_quotation_details) {
  return {
    type: LOAD_RECORD_QUOTATION_DETAILS_SUCCESS,
    record_quotation_details,
  }
}

/**
 * @param {string} error
 */

export function loadRecordQuotationDetailsError(error) {
  return {
    type: LOAD_RECORD_QUOTATION_DETAILS_ERROR,
    error,
  }
}
export function createQuotationRecord(
  quotationData,
  record,
  setSubmitting,
  redirect
) {
  console.log("record", quotationData)
  return {
    type: CREATE_QUOTATION_RECORD,
    quotationData,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createQuotationRecordSuccess(quotationData, record, success) {
  console.log("record", quotationData)
  return {
    type: CREATE_QUOTATION_RECORD_SUCCESS,
    quotationData,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function createQuotationRecordError(error) {
  return {
    type: CREATE_QUOTATION_RECORD_ERROR,
    error,
  }
}
export function updateQuotationRecord(quotationData) {
  return {
    type: UPDATE_QUOTATION_RECORD,
    quotationData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateQuotationRecordSuccess(quotationData, record, success) {
  return {
    type: UPDATE_QUOTATION_RECORD_SUCCESS,
    quotationData,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateQuotationRecordError(error) {
  return {
    type: UPDATE_QUOTATION_RECORD_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @returns
 */
export function deleteQuotationRecord(id, quotationRemoveId) {
  const quotationLeadId = id
  return {
    type: DELETE_QUOTATION_RECORD,
    quotationLeadId,
    quotationRemoveId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteQuotationRecordSuccess(id, quotationRemoveId, success) {
  const quotationLeadId = id

  return {
    type: DELETE_QUOTATION_RECORD_SUCCESS,
    quotationLeadId,
    quotationRemoveId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteQuotationRecordError(error) {
  return {
    type: DELETE_QUOTATION_RECORD_ERROR,
    error,
  }
}

////  Deliverable Section

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadDeliverableDetails(id) {
  return {
    type: LOAD_DELIVERABLE_DETAILS,
    id,
  }
}


/**
 *
 * @param {object} deliverable_details
 * @returns
 */

export function loadDeliverableDetailsSuccess(deliverable_details) {
  return {
    type: LOAD_DELIVERABLE_DETAILS_SUCCESS,
    deliverable_details,
  }
}

/**
 * @param {string} error
 */

export function loadDeliverableDetailsError(error) {
  return {
    type: LOAD_DELIVERABLE_DETAILS_ERROR,
    error,
  }
}


/**
 *
 * @param {integer} id
 * @returns
 */
export function loadECDeliverableDetails(id) {
  return {
    type: LOAD_EC_DELIVERABLE_DETAILS,
    id,
  }
}
/**
 *
 * @param {object} deliverable_details
 * @returns
 */

export function loadECDeliverableDetailsSuccess(ec_deliverable_details) {
  return {
    type: LOAD_EC_DELIVERABLE_DETAILS_SUCCESS,
    ec_deliverable_details,
  }
}

/**
 * @param {string} error
 */

export function loadECDeliverableDetailsError(error) {
  return {
    type: LOAD_EC_DELIVERABLE_DETAILS_ERROR,
    error,
  }
}
export function createDeliverable(
  deliverData,
  record,
  setSubmitting,
  redirect
) {
  console.log("record", deliverData)
  return {
    type: CREATE_DELIVERABLE,
    deliverData,
    record,
    setSubmitting,
    redirect,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createDeliverableSuccess(deliverData, record, success) {
  console.log("record", deliverData)
  return {
    type: CREATE_DELIVERABLE_SUCCESS,
    deliverData,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function createDeliverableError(error) {
  return {
    type: CREATE_DELIVERABLE_ERROR,
    error,
  }
}
export function updateDeliverable(deliverData) {
  return {
    type: UPDATE_DELIVERABLE,
    deliverData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateDeliverableSuccess(deliverData, record, success) {
  return {
    type: UPDATE_DELIVERABLE_SUCCESS,
    deliverData,
    record,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateDeliverableError(error) {
  return {
    type: UPDATE_DELIVERABLE_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteDeliverable(id, deliverableRemoveId) {
  const deliverableLeadId = id

  return {
    type: DELETE_DELIVERABLE,
    deliverableLeadId,
    deliverableRemoveId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteDeliverableSuccess(id, deliverableRemoveId, success) {
  const deliverableLeadId = id

  return {
    type: DELETE_DELIVERABLE_SUCCESS,
    deliverableLeadId,
    deliverableRemoveId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteDeliverableError(error) {
  return {
    type: DELETE_DELIVERABLE_ERROR,
    error,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(quotationRecordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    quotationRecordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadDeliverableRecordsMetaData() {
  return {
    type: LOAD_DELIVERABLES_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadDeliverableRecordsMetaDataSuccess(deliverablesMetaData) {
  return {
    type: LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS,
    deliverablesMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadDeliverableRecordsMetaDataError(error) {
  return {
    type: LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadInstructionsRecordsMetaData() {
  return {
    type: LOAD_INSTRUCTIONS_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadInstructionsRecordsMetaDataSuccess(instructionsMetaData) {
  return {
    type: LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS,
    instructionsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadInstructionsRecordsMetaDataError(error) {
  return {
    type: LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Value Insert
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadValueInsert(id) {
  return {
    type: LOAD_VALUE_INSERT,
    id,
  }
}

export function loadValueInsertSuccess(value_insert) {
  return {
    type: LOAD_VALUE_INSERT_SUCCESS,
    value_insert,
  }
}

/**
 * @param {string} error
 */

export function loadValueInsertError(error) {
  return {
    type: LOAD_VALUE_INSERT_ERROR,
    error,
  }
}

export function createValueInsert(valueInsert) {
  console.log("record", valueInsert)
  return {
    type: CREATE_VALUE_INSERT,
    valueInsert,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createValueInsertSuccess(valueInsert, success) {
  console.log("record", valueInsert)
  return {
    type: CREATE_VALUE_INSERT_SUCCESS,
    valueInsert,
    success,
  }
}

/**
 * @param {string} error
 */
export function createValueInsertError(error) {
  return {
    type: CREATE_VALUE_INSERT_ERROR,
    error,
  }
}

export function updateValueInsert(valueInsert) {
  console.log("valueInsert", valueInsert)

  return {
    type: UPDATE_VALUE_INSERT,
    valueInsert,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateValueInsertSuccess(valueInsert, success) {
  return {
    type: UPDATE_VALUE_INSERT_SUCCESS,
    valueInsert,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateValueInsertError(error) {
  return {
    type: UPDATE_VALUE_INSERT_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteValueInsert(valueInsert) {
  return {
    type: DELETE_VALUE_INSERT,
    valueInsert,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteValueInsertSuccess(valueInsert, success) {
  return {
    type: DELETE_VALUE_INSERT_SUCCESS,
    valueInsert,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteValueInsertError(error) {
  return {
    type: DELETE_VALUE_INSERT_ERROR,
    error,
  }
}

//Expiry Date

export function updateExpiryDate(expiryDate) {
  return {
    type: UPDATE_EXPIRY_DATE,
    expiryDate,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateExpiryDateSuccess(expiryDate, success) {
  return {
    type: UPDATE_EXPIRY_DATE_SUCCESS,
    expiryDate,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateExpiryDateError(error) {
  return {
    type: UPDATE_EXPIRY_DATE_ERROR,
    error,
  }
}

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadInstructions(id) {
  return {
    type: LOAD_INSTRUCTIONS,
    id,
  }
}

export function loadInstructionsSuccess(instructions) {
  return {
    type: LOAD_INSTRUCTIONS_SUCCESS,
    instructions,
  }
}

/**
 * @param {string} error
 */

export function loadInstructionsError(error) {
  return {
    type: LOAD_INSTRUCTIONS_ERROR,
    error,
  }
}

export function createInstruction(specialInstructions) {
  console.log("record", specialInstructions)
  return {
    type: CREATE_INSTRUCTIONS,
    specialInstructions,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createInstructionSuccess(specialInstructions, success) {
  console.log("record", specialInstructions)
  return {
    type: CREATE_INSTRUCTIONS_SUCCESS,
    specialInstructions,
    success,
  }
}

/**
 * @param {string} error
 */
export function createInstructionError(error) {
  return {
    type: CREATE_INSTRUCTIONS_ERROR,
    error,
  }
}

export function updateInstruction(specialInstructions) {
  return {
    type: UPDATE_INSTRUCTIONS,
    specialInstructions,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateInstructionSuccess(specialInstructions, success) {
  return {
    type: UPDATE_INSTRUCTIONS_SUCCESS,
    specialInstructions,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateInstructionError(error) {
  return {
    type: UPDATE_INSTRUCTIONS_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteInstruction(id, instructionsId) {
  const leadId = id

  return {
    type: DELETE_INSTRUCTIONS,
    leadId,
    instructionsId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteInstructionSuccess(id, instructionsId, success) {
  const leadId = id
  return {
    type: DELETE_INSTRUCTIONS_SUCCESS,
    leadId,
    instructionsId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteInstructionError(error) {
  return {
    type: DELETE_INSTRUCTIONS_ERROR,
    error,
  }
}

//Photography event list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadPhotography(id) {
  return {
    type: LOAD_PHOTOGRAPHY,
    id,
  }
}

export function loadPhotographySuccess(checklist_details) {
  return {
    type: LOAD_PHOTOGRAPHY_SUCCESS,
    checklist_details,
  }
}

/**
 * @param {string} error
 */

export function loadPhotographyError(error) {
  return {
    type: LOAD_PHOTOGRAPHY_ERROR,
    error,
  }
}

export function createPhotography(checklist) {
  console.log("record", checklist)
  return {
    type: CREATE_PHOTOGRAPHY,
    checklist,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createPhotographySuccess(checklist, success) {
  console.log("record", checklist)
  return {
    type: CREATE_PHOTOGRAPHY_SUCCESS,
    checklist,
    success,
  }
}

/**
 * @param {string} error
 */
export function createPhotographyError(error) {
  return {
    type: CREATE_PHOTOGRAPHY_ERROR,
    error,
  }
}

export function updatePhotography(checklist) {
  return {
    type: UPDATE_PHOTOGRAPHY,
    checklist,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updatePhotographySuccess(checklist, success) {
  return {
    type: UPDATE_PHOTOGRAPHY_SUCCESS,
    checklist,
    success,
  }
}

/**
 * @param {string} error
 */
export function updatePhotographyError(error) {
  return {
    type: UPDATE_PHOTOGRAPHY_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deletePhotography(id, eventCheckListId) {
  const leadId = id
  return {
    type: DELETE_PHOTOGRAPHY,
    leadId,
    eventCheckListId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deletePhotographySuccess(id, success, eventCheckListId) {
  const leadId = id

  return {
    type: DELETE_PHOTOGRAPHY_SUCCESS,
    leadId,
    eventCheckListId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deletePhotographyError(error) {
  return {
    type: DELETE_PHOTOGRAPHY_ERROR,
    error,
  }
}

//Photography event list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadService(searchFilter) {
  return {
    type: LOAD_SERVICE_DETAILS,
    searchFilter,
  }
}

export function loadServiceSuccess(service_details) {
  return {
    type: LOAD_SERVICE_DETAILS_SUCCESS,
    service_details,
  }
}

/**
 * @param {string} error
 */

export function loadServiceError(error) {
  return {
    type: LOAD_SERVICE_DETAILS_ERROR,
    error,
  }
}

//Service count total value

//Photography event list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadServiceTotal(id) {
  return {
    type: LOAD_SERVICE_ACCOUNT,
    id,
  }
}

export function loadServiceTotalSuccess(service_total_account) {
  return {
    type: LOAD_SERVICE_ACCOUNT_SUCCESS,
    service_total_account,
  }
}

/**
 * @param {string} error
 */

export function loadServiceTotalError(error) {
  return {
    type: LOAD_SERVICE_ACCOUNT_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function approvalRequestQc(id, leadQuotationId) {
  const leadId = id
  return {
    type: APPROVE_QC_REQUEST,
    leadId,
    leadQuotationId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function approvalRequestQcSuccess(id, success, leadQuotationId) {
  const leadId = id

  return {
    type: APPROVE_QC_REQUEST_SUCCESS,
    leadId,
    leadQuotationId,
    success,
  }
}

/**
 * @param {string} error
 */
export function approvalRequestQcError(error) {
  return {
    type: APPROVE_QC_REQUEST_ERROR,
    error,
  }
}

//Re-approve update API

/**
 *
 * @returns
 */
export function updateQcReapprove(qcRequestData) {
  return {
    type: UPDATE_QC_REAPPROVE,
    qcRequestData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function updateQcReapproveSuccess(success, qcRequestData) {
  return {
    type: UPDATE_QC_REAPPROVE_SUCCESS,
    qcRequestData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateQcReapproveError(error) {
  return {
    type: UPDATE_QC_REAPPROVE_ERROR,
    error,
  }
}

// Quatation
export function loadQuotationHistoryDetails(record) {
  return {
    type: LOAD_QUOTATION_HISTORY_DETAILS,
    record,
  }
}

export function loadQuotationHistoryDetailsSuccess(quotation_history) {
  console.log("history qua", quotation_history)
  return {
    type: LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS,
    quotation_history,
  }
}

export function loadQuotationHistoryDetailsError(error) {
  return {
    type: LOAD_QUOTATION_HISTORY_DETAILS_ERROR,
    error,
  }
}

//SalesApproval
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesApproval() {
  return {
    type: LOAD_SALES_APPROVAL,
  }
}

export function loadSalesApprovalSuccess(sales_details) {
  return {
    type: LOAD_SALES_APPROVAL_SUCCESS,
    sales_details,
  }
}

/**
 * @param {string} error
 */

export function loadSalesApprovalError(error) {
  return {
    type: LOAD_SALES_APPROVAL_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

//Qc list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadQcHistory(id) {
  return {
    type: LOAD_QC_HISTORY,
    id,
  }
}

export function loadQcHistorySuccess(qc_history) {
  return {
    type: LOAD_QC_HISTORY_SUCCESS,
    qc_history,
  }
}

/**
 * @param {string} error
 */

export function loadQcHistoryError(error) {
  return {
    type: LOAD_QC_HISTORY_ERROR,
    error,
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadQCLayoutMaster(companyId) {
  var payloadLayoutMaster = {
    status: "active",
    companyId: companyId[0],
  }
  return {
    type: LOAD_QC_LAYOUT_MASTER,
    payloadLayoutMaster,
  }
}

export function loadQCLayoutMasterSuccess(qc_layout_master) {
  return {
    type: LOAD_QC_LAYOUT_MASTER_SUCCESS,
    qc_layout_master,
  }
}
//Quotation final submit

export function updateQuotationList(quotationList) {
  return {
    type: UPDATE_QUOTATION_LIST,
    quotationList,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateQuotationListSuccess(quotationList, success) {
  return {
    type: UPDATE_QUOTATION_LIST_SUCCESS,
    quotationList,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateQuotationListError(error) {
  return {
    type: UPDATE_QUOTATION_LIST_ERROR,
    error,
  }
}

//load get quotation details

/**
 * @param {integer} id
 */
export function loadQuotationList(id) {
  return {
    type: LOAD_QUOTATION_LIST,
    id,
  }
}

export function loadQuotationListSuccess(quotationList) {
  return {
    type: LOAD_QUOTATION_LIST_SUCCESS,
    quotationList,
  }
}

/**
 * @param {string} error
 */

export function loadQCLayoutMasterError(error) {
  return {
    type: LOAD_QC_LAYOUT_MASTER_ERROR,
    error,
  }
}
export function loadQuotationListError(error) {
  return {
    type: LOAD_QUOTATION_LIST_ERROR,
    error,
  }
}

export function loadQCLayoutSegment() {
  return {
    type: LOAD_QC_LAYOUT_SEGMENT,
  }
}

export function loadQCLayoutSegmentSuccess(qc_layout_segment) {
  return {
    type: LOAD_QC_LAYOUT_SEGMENT_SUCCESS,
    qc_layout_segment,
  }
}

export function loadQCLayoutSegmentError(error) {
  return {
    type: LOAD_QC_LAYOUT_SEGMENT_ERROR,
    error,
  }
}

//QUotation preview
/**
 * @param {integer} id
 */
export function loadQuotationPreview(id) {
  return {
    type: LOAD_QUOTATION_PREVIEW,
    id,
  }
}

export function loadQuotationPreviewSuccess(quotation_preview) {
  return {
    type: LOAD_QUOTATION_PREVIEW_SUCCESS,
    quotation_preview,
  }
}

/**
 * @param {string} error
 */

export function loadQuotationPreviewError(error) {
  return {
    type: LOAD_QUOTATION_PREVIEW_ERROR,
    error,
  }
}
//QUotation preview
/**
 * @param {integer} id
 */
export function updateQuotationPreview(quotationPreview) {
  return {
    type: UPDATE_QUOTATION_PREVIEW,
    quotationPreview,
  }
}

export function updateQuotationPreviewSuccess(quotationPreview, success) {
  return {
    type: UPDATE_QUOTATION_PREVIEW_SUCCESS,
    quotationPreview,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateQuotationPreviewError(error) {
  return {
    type: UPDATE_QUOTATION_PREVIEW_ERROR,
    error,
  }
}


//QUotation preview
/**
 * @param {integer} id
 */
export function addSegmentPreview(segmentPreview) {
  return {
    type: ADD_SEGMENT_PREVIEW,
    segmentPreview,
  }
}

export function addSegmentPreviewSuccess(segmentPreview, success) {
  return {
    type: ADD_SEGMENT_PREVIEW_SUCCESS,
    segmentPreview,
    success,
  }
}

/**
 * @param {string} error
 */

export function addSegmentPreviewError(error) {
  return {
    type: ADD_SEGMENT_PREVIEW_ERROR,
    error,
  }
}

export function addTeamAssign(team_details) {
  return {
    type: ADD_TEAM_ASSIGN,
    team_details,
  }
}

export function addTeamAssignSuccess(team_details) {
  return {
    type: ADD_TEAM_ASSIGN_SUCCESS,
    team_details

  }
}


export function addTeamAssignError(error) {
  return {
    type: ADD_TEAM_ASSIGN_ERROR,
    error,
  }
}

export function addProductAssign(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN,
    product_details,
  }
}

export function addProductAssignSuccess(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN_SUCCESS,
    product_details

  }
}


export function addProductAssignError(error) {
  return {
    type: ADD_PRODUCT_ASSIGN_ERROR,
    error,
  }
}


export function updateCrmDeliver(crmDeliver) {
  return {
    type: UPDATE_CRM_DELIVER,
    crmDeliver,
  }
}

export function updateCrmDeliverSuccess(crmDeliver) {
  return {
    type: UPDATE_CRM_DELIVER_SUCCESS,
    crmDeliver

  }
}


export function updateCrmDeliverError(error) {
  return {
    type: UPDATE_CRM_DELIVER_ERROR,
    error,
  }
}

export function loadDeliverableEmployee() {
  return {
    type: LOAD_DELIVERABLE_EMPLOYEE,
  }
}

export function loadDeliverableEmployeeSuccess(deliver_employeelist) {
  return {
    type: LOAD_DELIVERABLE_EMPLOYEE_SUCCESS,
    deliver_employeelist,
  }
}


export function loadDeliverableEmployeeError(error) {
  return {
    type: LOAD_DELIVERABLE_EMPLOYEE_ERROR,
    error,
  }
}

//discount preview


/**
 *
 * @returns
 */
export function updateDiscountPreview(discountPreview) {
  return {
    type: UPDATE_DISCOUNT_PREVIEW,
    discountPreview,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function updateDiscountPreviewSuccess(success, discountPreview) {
  return {
    type: UPDATE_DISCOUNT_PREVIEW_SUCCESS,
    discountPreview,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateDiscountPreviewError(error) {
  return {
    type: UPDATE_DISCOUNT_PREVIEW_ERROR,
    error,
  }
}


export function updateProcess(submitStatus) {
  return {
    type: UPDATE_PROCESS,
    submitStatus,
  }
}

export function updateProcessSuccess() {
  return {
    type: UPDATE_PROCESS_SUCCESS,
  }
}


export function updateProcessError(processError) {
  return {
    type: UPDATE_PROCESS_ERROR,
    processError,
  }
}
//add crm

export function addCrmAssign(crm_details){
  return{
    type:ADD_CRM,
    crm_details
  }
}
export function addCrmAssignSuccess(crmSuccess) {
  return {
    type: ADD_CRM_SUCCESS,
  crmSuccess
  }
}
export function addCrmAssignError(crmError) {
  return {
    TYPE:ADD_CRM_ERROR,
    crmError,
  }
}
export function loadProcessStatus() {
  return {
    type: LOAD_PROCESS_STATUS,
  }
}

export function loadProcessStatusSuccess(processStatus) {
  return {
    type: LOAD_PROCESS_STATUS_SUCCESS,
    processStatus,
  }
}

/**
 * @param {string} error
 */

export function loadProcessStatusError(error) {
  return {
    type: LOAD_PROCESS_STATUS_ERROR,
    error,
  }
}
const actions = {
  createQuotationRecord,
  createQuotationRecordError,
  createQuotationRecordSuccess,
  deleteQuotationRecord,
  deleteQuotationRecordSuccess,
  deleteQuotationRecordError,
  updateQuotationRecordError,
  updateQuotationRecord,
  updateQuotationRecordSuccess,
  loadRecordQuotationDetails,
  loadRecordQuotationDetailsSuccess,
  loadRecordQuotationDetailsError,
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadDeliverableRecordsMetaData,
  loadDeliverableRecordsMetaDataSuccess,
  loadDeliverableRecordsMetaDataError,
  loadInstructionsRecordsMetaData,
  loadInstructionsRecordsMetaDataSuccess,
  loadInstructionsRecordsMetaDataError,

  createDeliverable,
  createDeliverableError,
  createDeliverableSuccess,
  deleteDeliverable,
  deleteDeliverableSuccess,
  deleteDeliverableError,
  updateDeliverableError,
  updateDeliverable,
  updateDeliverableSuccess,
  loadDeliverableDetails,
  loadDeliverableDetailsSuccess,
  loadDeliverableDetailsError,

  createValueInsert,
  createValueInsertError,
  createValueInsertSuccess,
  deleteValueInsert,
  deleteValueInsertSuccess,
  deleteValueInsertError,
  updateValueInsertError,
  updateValueInsert,
  updateValueInsertSuccess,
  loadValueInsert,
  loadValueInsertSuccess,
  loadValueInsertError,

  updateExpiryDate,
  updateExpiryDateSuccess,
  updateExpiryDateError,

  createInstruction,
  createInstructionError,
  createInstructionSuccess,
  deleteInstruction,
  deleteInstructionSuccess,
  deleteInstructionError,
  updateInstructionError,
  updateInstruction,
  updateInstructionSuccess,
  loadInstructions,
  loadInstructionsSuccess,
  loadInstructionsError,

  createPhotography,
  createPhotographyError,
  createPhotographySuccess,
  deletePhotography,
  deletePhotographySuccess,
  deletePhotographyError,
  updatePhotographyError,
  updatePhotography,
  updatePhotographySuccess,
  loadPhotography,
  loadPhotographySuccess,
  loadPhotographyError,
  loadService,
  loadServiceSuccess,
  loadServiceError,

  loadServiceTotal,
  loadServiceTotalSuccess,
  loadServiceTotalError,

  loadSalesApproval,
  loadSalesApprovalSuccess,
  loadSalesApprovalError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadQcHistory,
  loadQcHistorySuccess,
  loadQcHistoryError,

  approvalRequestQc,
  approvalRequestQcSuccess,
  approvalRequestQcError,

  updateQcReapprove,
  updateQcReapproveSuccess,
  updateQcReapproveError,

  loadQuotationHistoryDetails,
  loadQuotationHistoryDetailsSuccess,
  loadQuotationHistoryDetailsError,

  updateQuotationList,
  updateQuotationListSuccess,
  updateQuotationListError,

  loadQuotationList,
  loadQuotationListSuccess,
  loadQuotationListError,

  loadQCLayoutMaster,
  loadQCLayoutMasterSuccess,
  loadQCLayoutMasterError,

  loadQCLayoutSegment,
  loadQCLayoutSegmentSuccess,
  loadQCLayoutSegmentError,

  //Qc preview
  loadQuotationPreview,
  loadQuotationPreviewSuccess,
  loadQuotationPreviewError,

  updateQuotationPreview,
  updateQuotationPreviewSuccess,
  updateQuotationPreviewError,

  addSegmentPreview,
  addSegmentPreviewSuccess,
  addSegmentPreviewError,

  addTeamAssign,
  addTeamAssignSuccess,
  addTeamAssignError,

  addProductAssign,
  addProductAssignSuccess,
  addProductAssignError,

  updateCrmDeliver,
  updateCrmDeliverSuccess,
  updateCrmDeliverError,

  loadECDeliverableDetails,
  loadECDeliverableDetailsSuccess,
  loadECDeliverableDetailsError,

  loadDeliverableEmployee,
  loadDeliverableEmployeeSuccess,
  loadDeliverableEmployeeError,

  //Discount preview

  updateDiscountPreview,
  updateDiscountPreviewSuccess,
  updateDiscountPreviewError,

  updateProcess,
  updateProcessSuccess,
  updateProcessError,

  addCrmAssign,
  addCrmAssignSuccess,
  addCrmAssignError,

  loadProcessStatus,
  loadProcessStatusSuccess,
  loadProcessStatusError
}

export default actions
